import { Field } from '@/types/fields';

export enum Status {
  initial = 0,
  completed = 2,
  error = 4,
}

export interface BaseStep {
  readonly type: string;
  readonly path: string;
}

export interface ParentStep<T> extends BaseStep {
  readonly title: string;
  readonly children: readonly ChildStep<T[keyof T] | T>[];
}

export interface ChildStep<T> extends BaseStep {
  readonly accessor: readonly string[];
  readonly title: string;
  readonly description?: string;
  readonly fields: readonly Field<T>[];
  readonly skip?: string | ((data: T) => string | undefined);
}
